import React, { useEffect, useState } from 'react';
import { listProjects, deleteProject } from '../../../services/projectApi';
import './OpenProjectDialog.css';

const OpenProjectDialog = ({ isOpen, onClose, onSelect }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    setError('');
    listProjects()
      .then(p => setProjects(p))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [isOpen]);

  const handleDelete = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm('Bu projeyi silmek istediğinize emin misiniz?')) return;
    try {
      await deleteProject(id);
      setProjects(prev => prev.filter(p => p.id !== id));
    } catch (err) {
      alert('Silme hatası: ' + err.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="open-project-overlay" onClick={onClose}>
      <div className="open-project-dialog" onClick={e => e.stopPropagation()}>
        <div className="open-project-header">
          <h3>Proje Aç</h3>
          <button className="open-project-close" onClick={onClose}>&times;</button>
        </div>

        <div className="open-project-body">
          {loading && <p className="open-project-info">Yükleniyor...</p>}
          {error && <p className="open-project-error">{error}</p>}
          {!loading && !error && projects.length === 0 && (
            <p className="open-project-info">Henüz kayıtlı projeniz yok.</p>
          )}
          {projects.map(p => (
            <div key={p.id} className="open-project-item" onClick={() => onSelect(p)}>
              <div className="open-project-item-info">
                <span className="open-project-item-name">{p.name}</span>
                <span className="open-project-item-date">
                  {p.updatedAt ? new Date(p.updatedAt).toLocaleString('tr-TR') : ''}
                  {p.hasDraft && <span className="open-project-draft-badge">taslak</span>}
                </span>
              </div>
              <button className="open-project-item-delete" onClick={e => handleDelete(e, p.id)} title="Sil">&times;</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OpenProjectDialog;
